/** Narrows an unknown JSON value to a plain object record. */
export function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function sanitizeKeysThatContainsAnyString(object: any, bannedStrings: Array<string>): any {
    const lowerCaseBannedStrings = bannedStrings.map((str) => str.toLowerCase());

    return Object.keys(object).reduce((obj, key) => {
        const containsBannedString =
            lowerCaseBannedStrings.find((term) => key.toLowerCase().includes(term)) != undefined;

        return {
            ...obj,
            [key]: containsBannedString ? '##########' : object[key],
        };
    }, {});
}

export function sanitizeURLThatContainsAnyString(path: string, bannedStrings: Array<string>, remove = true): string {
    const lowerCaseBannedStrings = bannedStrings.map((str) => str.toLowerCase());
    let redactedPath = path;

    for (const bannedString of lowerCaseBannedStrings) {
        redactedPath = redactedPath.replace(
            new RegExp(`${bannedString}=([^&]*)`),
            remove ? '' : `${bannedString}=**redacted**`,
        );
    }

    return redactedPath;
}
